<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row class="mb-4">
      <b-col class="mt-2 text-right" v-if="blnBtnHerramientas">
        <em
            v-if="activoEnDiagnocat && !loaderDiagnocat"
            class="boton_diagnocat sombraModales"
            v-b-tooltip.hover.v-light.topright="'SINCRONIZAR ESTUDIOS DE DIAGNOCAT'"
            @click="autoguardadoDiagnoEce()"
            style="  margin-bottom: clamp(-14px, -2vw, -5px) !important;"
        ></em>
        <b-spinner small label="Small Spinner" v-if="loaderDiagnocat" style="margin: -2px 0.5vw !important; color: #7564ed !important;"></b-spinner>
        <b-button v-if="blnBtnVistaPrevia"
                  class="mr-2 shadow-botones sombraModales marginbotones paddingbotones2"
                  variant="light"
                  style="cursor: pointer"
                  @click="ocultarCards()"
                  v-b-popover.hover.topleft="blnCards ? 'Ver cuadricula':'Ver lista'"
        >
          <em class="vista_iconos_peques_svg primary sm" v-if="blnCards"></em>
          <font-awesome-icon style="color: var(--color-dentalia-1-v2)" icon="list" v-else/>
        </b-button>
        <b-button variant="light"
                  @click="subirHerramientaModal()"
                  class="mr-2 shadow-botones marginbotones paddingbotones2"
                  v-b-popover.hover.topleft="'Agregar nueva herramienta'"
        >
          <em class="mas_azul_svg primary sm"></em>
        </b-button>
        <b-button
            v-if="width <= 900"
            pill
            variant="light"
            size="sm"
            @click="ocultarDirectorio()"
            style="color: #0069a9;"
        >
          <font-awesome-icon icon="bars"/>
        </b-button>
      </b-col>
      <b-col class="mt-2 text-right" v-if="!blnBtnHerramientas">
        <b-button v-if="blnBtnVistaPrevia"
                  class="mr-2 shadow-botones marginbotones paddingbotones2"
                  variant="light"
                  style="cursor: pointer"
                  @click="ocultarCards()"
                  v-b-popover.hover.topleft="blnCards ? 'Ver cuadricula':'Ver lista'"
        >
          <em class="vista_iconos_peques_svg primary sm" v-if="blnCards"></em>
          <font-awesome-icon style="color: var(--color-dentalia-1-v2)" icon="list" v-else/>
        </b-button>
        <b-button variant="light"
                  @click="subirHerramientaOrtodonticaModal()"
                  class="mr-2 shadow-botones marginbotones paddingbotones2"
                  v-b-popover.hover.topleft="'Subir Archivo'"
        >
          <em class="mas_azul_svg primary sm"></em>
        </b-button>
        <b-button
            v-if="width <= 900"
            class="mr-2 shadow-botones"
            pill
            variant="light"
            size="sm"
            @click="ocultarDirectorio()"
            style="color: #0069a9;"
        >
          <font-awesome-icon icon="bars"/>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-navbar toggleable="lg" style="width: 100vw">
        <b-navbar-brand
            style="color: #8f8f8f; font-size: 13px"
            v-for="(item) in rutasMostra"
            v-bind:key="item.idRuta"
        >
          {{ item.text }}
          <font-awesome-icon icon="chevron-right" class="ml-2"/>
        </b-navbar-brand>
      </b-navbar>
    </b-row>
    <div v-if="loader">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <div v-if="loaderDescarga">
      <b-progress :max="archivoDescargando.contentLength" style="width: 80%; margin: 0 auto; height: 1.5rem;">
        <b-progress-bar
            :value="archivoDescargando.recibido"
            :label="`Descargando....${archivoDescargando.progreso}%`"
            variant="success"
            striped
            animated
        ></b-progress-bar>
      </b-progress>
    </div>


    <b-row style="max-height: 96vh !important;" v-if="!loader && !loaderDescarga ">
      <!--    AQUI LA LISTA-->
      <div class="col-12" v-if="blnCards">
        <b-table-simple class="text-left" hover fixed responsive sticky-header>
          <b-thead class="columnasTablaSinColor">
            <b-tr>
              <b-th class="border-top-0">Nombre del archivo</b-th>
              <b-th class="border-top-0" v-if="blnBtnVistaPrevia">Usuario alta</b-th>
              <b-th class="border-top-0">Fecha alta</b-th>
              <b-th class="border-top-0" v-if="blnBtnVistaPrevia">Tamaño del archivo</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <template v-for="(archivo, index) in listArchivos">
              <b-tr :key="'lst'+index" style="border-top: 1px solid white" @click="blnBtnVistaPrevia ? mostrarVisor(archivo.Name) : menuDescargar2(archivo)">
                <b-td style="border-top: 1px solid white"
                    @contextmenu.prevent.self="menuDescargar($event, archivo, { menu: 'menu1' })">
                  <p style="font-size: small; cursor: pointer;" class="m-0 romperTexto" @contextmenu.prevent.self="menuDescargar($event, archivo, { menu: 'menu1' })">
                  <font-awesome-icon
                      v-if="archivo.extension === 'carpeta'"
                      icon="folder"
                      class="mr-1"
                      style="font-size: 18px; color: #0e6ba9"
                  />

                  <font-awesome-icon
                      v-if="archivo.extension === 'pdf'"
                      icon="file-pdf"
                      class="mr-1"
                      style="font-size: 18px; color: red"
                  />

                  <em class="img_claro_svg mr-1"
                      style="width: 18px;"
                      v-if="archivo.extension === 'png' ||
                            archivo.extension === 'jpg' ||
                            archivo.extension === 'jpeg'"
                  ></em>

                    <font-awesome-icon
                        v-if="
                      archivo.extension !== 'png' &&
                      archivo.extension !== 'jpg' &&
                      archivo.extension !== 'jpeg' &&
                      archivo.extension !== 'pdf' &&
                      archivo.extension !== 'carpeta'
                    "
                        class="mr-1"
                        icon="file"
                        style="font-size: 18px; color: #17A2B8"
                    />

                    {{ archivo.Name }}
                  </p>
                </b-td>
                <b-td v-if="blnBtnVistaPrevia" style="border-top: 1px solid white">{{ archivo.nombreUsuario }}</b-td>
                <b-td style="border-top: 1px solid white">{{ archivo.TimeCreated | formatoFecha}}</b-td>
                <b-td v-if="blnBtnVistaPrevia" style="border-top: 1px solid white">{{ archivo.Length | bytesToKBOrMB }}</b-td>
              </b-tr>
            </template>

          </b-tbody>
        </b-table-simple>

        <b-alert
            v-if="listArchivos.length === 0"
            variant="warning"
            show>
          No hay datos
        </b-alert>

      </div>

<!--      AQUI LAS CARD'S!!!!!!!!!!!!-->
      <div class="w-100" v-if="!blnCards">
        <div class="ml-2 mt-2 pr-3 estiloCards">
          <b-row cols="2" cols-md="3" cols-lg="4" cols-xl="5" class="d-flex align-items-center">
            <template v-for="(archivo, index) in listArchivos">
              <b-col class="mb-3" :key="'archivo-'+index" @click="mostrarVisor(archivo.Name)">
                <img alt="img" v-if="archivo.extension === 'png' ||
                        archivo.extension === 'jpeg' ||
                        archivo.extension === 'jpg'  &&
                    archivo.imagenBase64 !== undefined &&
                    archivo.imagenBase64 !== null &&
                    archivo.imagenBase64 !== ''" class="tamanioImg tamanioImg-lg"
                     :src="'data:image/jpeg;base64,'+archivo.imagenBase64"
                     @contextmenu.prevent.self="menuDescargar($event, archivo, { menu: 'menu1' })"/>

                <div v-if="
                  archivo.extension === 'pdf' &&
                  archivo.imagenBase64 !== undefined &&
                  archivo.imagenBase64 !== null &&
                  archivo.imagenBase64 !== ''
                ">
                  <pdf
                      v-for="i in 1"
                      :key="i"
                      :page="i"
                      :src="'data:application/pdf;base64,'+archivo.imagenBase64"
                      @page-loaded="renderizarPaginas($event)"
                  ></pdf>
                </div>

                <div v-if="archivo.extension !== 'png' &&
                  archivo.extension !== 'jpg'  &&
                  archivo.extension !== 'jpeg'  &&
                  archivo.extension !== 'pdf'  ||
                  archivo.imagenBase64 === undefined ||
                  archivo.imagenBase64 === null ||
                  archivo.imagenBase64 === ''"
                     @contextmenu.prevent.self="menuDescargar($event, archivo, { menu: 'menu1' })">
                  <img alt="img" style="object-fit: cover; width: 100%; height: 100%;" src="../../../assets/logoColor.png" @contextmenu.prevent.self="menuDescargar($event, archivo, { menu: 'menu1' })"/>
                  <span style="font-size: small;" class="bold" @contextmenu.prevent.self="menuDescargar($event, archivo, { menu: 'menu1' })">No hay vista previa</span>
                </div>


                <p style="font-size: small;"
                   class="m-0"
                   @contextmenu.prevent.self="menuDescargar($event, archivo, { menu: 'menu1' })">
                  {{ archivo.Name }}
                </p>
              </b-col>
            </template>
          </b-row>
        </div>
      </div>
    </b-row>
    <vue-context ref="menu1">
      <ul>
        <li
            v-if="this.rutaDescargar.extension === 'png' ||
          this.rutaDescargar.extension === 'jpg' ||
          this.rutaDescargar.extension === 'jpeg' ||
          this.rutaDescargar.extension === 'pdf'"
        >
          <a href="#" @click.prevent="mostrarVisor(null)">Vista previa</a>
        </li>

        <li
            v-if="$localStorageService.can('ECE_aws_descargar')  && rutaDescargar.extension !== 'carpeta'"
        >
          <a href="#" @click.prevent="descargarAchivo(rutaDescargar)">Descargar</a>
        </li>

        <li v-if="rutaDescargar.extension === 'carpeta'">
          <a href="#" @click.prevent="verArchivoFolder(null)">Abrir</a>
        </li>
        <li v-if="$localStorageService.can('ECE_01_eliminar')  && rutaDescargar.extension !== 'carpeta'">
          <a href="#" @click.prevent="eliminarArchivo()">Eliminar</a>
        </li>
      </ul>
    </vue-context>

    <b-modal v-model="showModalSubirHerramienta" centered no-close-on-backdrop size="md"
             no-close-on-esc    :hide-footer="true" >
      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
          <div class="headerTxt mLeft">Subir Herramienta</div>
        </div>
      </template>
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form-group
                id="idMotivo"
                label="Motivo:"
                label-for="input-1"
            >
              <b-form-select class="mb-3 redondeo" @change="obtenerArchivoExpedientePorFlujo($event)">
                <b-form-select-option
                    v-for="flujo in listaFlujoExpedinteDigital"
                    :key="flujo.idFlujoExpedienteDigital"
                    :value="flujo"
                >{{ flujo.flujoExpedienteDigial }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
                id="idTipoHerramienta"
                label="Tipo Herramientas:"
                label-for="input-2"
            >
              <b-form-select class="mb-3 redondeo" @change="obtieneExtensionesArchivo($event)">
                <b-form-select-option
                    v-for="(herramientas, index) in listaArchivoExpedinteDigital"
                    :key="index"
                    :value="herramientas"
                >{{ herramientas.nombreHerramienta }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row  v-if="tipoHerramienta !== null && listaArchivoAntesGuardar.length === 0">
          <b-col class="mt-2 text-center">
            <label for="subirArchivoInput"
                   class="btn btn-light icono-cargar" style="border-radius: 20px;">
                    <span class="colorWhite">
                              <em class="mas_azul_svg  mr-1 mt-1" style="height: 1em"></em>
                    </span>
            </label>
            <br>
            <span  style="font-size: small; font-weight:bold">
                               Cargar Archivos
                               </span>
            <b-form-file id="subirArchivoInput" type="file" multiple="multiple" v-model="archivoCarga"
                         style="display:none" ref="file-input"
                         @change="changeArchivoHerramienta($event)"/>
          </b-col>
        </b-row>
        <b-row  v-if="tipoHerramienta !== null && listaArchivoAntesGuardar.length > 0">
          <b-col class="mt-2">
               <span style="font-size: small; font-weight:bold">
                               Archivos Seleccionado
                               </span>
            <hr>
          </b-col>
          <b-col class="mt-2 text-right col-3" v-if="!loaderArchivo">
            <label for="subirArchivoInput"
                   class="btn btn-light icono-cargar"  style="border-radius: 20px;">
                    <span class="colorWhite">
                              <em class="mas_azul_svg  mr-1 mt-1" style="height: 1em"></em>
                    </span>
            </label>
            <br>
            <b-form-file id="subirArchivoInput" type="file" multiple="multiple" v-model="archivoCarga"
                         style="display:none" ref="file-input"
                         @change="changeArchivoHerramienta($event)"/>
          </b-col>
          <hr>
        </b-row>
        <b-row class="text-center" v-if="listaArchivoAntesGuardar.length > 0">
          <b-col>
            <b-row v-for="(item, index) of listaArchivoAntesGuardar" :key="index">
              <b-col
                  style="font-size: small; text-align: center; align-content: center;"
                  class="col-12 col-sm-12 col-md-6"
              >
                {{item.nombreArchivo}}
              </b-col>
              <b-col>
                <span v-if="item.estusCarga && !loaderArchivo"
                      style="color: green; font-size: small; text-align: center"
                      class="col-12 col-sm-12 col-md-6"
                >
                   "Listo para cargarse"
                </span>
                <span v-else-if="!item.estusCarga && !loaderArchivo" style="color: red; font-size: small">
                  "Error: formato no aceptado"
                </span>
                <span v-if="item.estusCarga && loaderArchivo"
                      style="color: green; font-size: small; text-align: center"
                      class="col-12 col-sm-12 col-md-6"
                >
                  <b-progress :max="100" height="1.5rem">
                    <b-progress-bar
                        :value="item.progreso"
                        :label="`Cargando....${item.progreso}%`"
                        variant="success"
                        striped
                        animated
                    ></b-progress-bar>
                  </b-progress>
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <div class="modal-footer">
        <b-button pill
                  v-if="listaArchivosGuardar.length > 0"
                  style="background-color: #0169aa; border-color: #0169aa;"
                  class="mr-3"
                  variant="primary"
                  :disabled="loaderArchivo"
                  @click="guardarHerramienta()"
        ><span v-if="!loaderArchivo">Cargar</span>
          <span v-if="loaderArchivo">Cargando...<b-spinner small></b-spinner></span>
        </b-button>
        <b-button
            pill
            style="background-color: #595959; border-color: #595959;"
            @click="cerrarModalHerramienta()"
        >Salir
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="showModalSubirHerramientaOrtodontica" centered no-close-on-backdrop size="md" no-close-on-esc :hide-footer="true">
      <template #modal-header="{ ok, close }">
        <div class="seccionTitle mLeft h5">
          <em class=" nuevo_cupon_svg" style=" height: 40px"></em>
          <div class="headerTxt mLeft">Subir Herramienta</div>
        </div>
      </template>
      <b-container fluid>
        <b-row  v-if="listaArchivoAntesGuardar.length === 0">
          <b-col class="mt-2 text-center">
            <label for="subirArchivoInput"
                   class="btn btn-light icono-cargar" style="border-radius: 20px;">
                    <span class="colorWhite">
                              <em class="mas_azul_svg  mr-1 mt-1" style="height: 1em"></em>
                    </span>
            </label>
            <br>
            <span  style="font-size: small; font-weight:bold">
                               Cargar Archivos
                               </span>
            <b-form-file id="subirArchivoInput" type="file" multiple="multiple" v-model="archivoCarga"
                         style="display:none" ref="file-input"
                         @change="change($event)"/>
          </b-col>
        </b-row>
        <b-row class="text-center" v-if="listaArchivoAntesGuardar.length > 0">
          <b-col>
            <b-row v-for="(item, index) of listaArchivoAntesGuardar" :key="index">
              <b-col
                  style="font-size: small; text-align: center; align-content: center;"
                  class="col-12 col-sm-12 col-md-6"
              >
                {{item.nombreArchivo}}
              </b-col>
              <b-col>
                <span v-if="item.estusCarga && !loaderArchivo"
                      style="color: green; font-size: small; text-align: center"
                      class="col-12 col-sm-12 col-md-6"
                >
                   "Listo para cargarse"
                </span>
                <span v-else-if="!item.estusCarga && !loaderArchivo" style="color: red; font-size: small">
                  "Error: formato no aceptado"
                </span>
                <span v-if="item.estusCarga && loaderArchivo"
                      style="color: green; font-size: small; text-align: center"
                      class="col-12 col-sm-12 col-md-6"
                >
                  <b-progress :max="100" height="1.5rem">
                    <b-progress-bar
                        :value="item.progreso"
                        :label="`Cargando....${item.progreso}%`"
                        variant="success"
                        striped
                        animated
                    ></b-progress-bar>
                  </b-progress>
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <div class="modal-footer">
        <b-button pill
                  v-if="listaArchivosGuardar.length > 0"
                  style="background-color: #0169aa; border-color: #0169aa;"
                  class="mr-3"
                  variant="primary"
                  :disabled="loaderArchivo"
                  @click="guardarHerramientaOrtodontica()"
        ><span v-if="!loaderArchivo">Cargar</span>
          <span v-if="loaderArchivo">Cargando...<b-spinner small></b-spinner></span>
        </b-button>
        <b-button
            pill
            style="background-color: #595959; border-color: #595959;"
            @click="cerrarModalHerramienta"
        >Salir
        </b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="modalVisorImg"
        centered
        no-close-on-backdrop
        hide-header-close
        hide-header
        hide-footer
        v-if="modalVisorImg"
        size="xl"
    >
      <b-row>
        <b-col cols="2">
          <em class="img_svg primary sm"></em>
          <span style="color: var(--color-dentalia-1-v2); font-weight: bold;"> Vista Previa</span>
        </b-col>
        <b-col cols="8" class="text-center romperTexto">
          <div style="font-size: small" v-if="listaVisor.length !== 0 ">
            {{ nombreArchivo }}
          </div>
        </b-col>
        <b-col cols="2" class="text-right">
          <b-icon icon="x" font-scale="2" @click="modalVisorImg = false; nombreArchivo = ''"></b-icon>
        </b-col>
      </b-row>

      <div v-if="esImagen">
        <VisorImagenesECE :listaImagenes="listaVisor" :index.sync="indexImagen"/>
      </div>
      <div v-else>
        <iframe
            class="archivo-frame"
            v-if="listArchivos[indexImagen].extension === 'pdf' && listArchivos[indexImagen].Length <= 1000000"
            :src="'data:application/pdf;base64,' + listArchivos[indexImagen].imagenBase64"
            title="Herramienta-frame"
        />
        <div
            v-if="
                listArchivos[indexImagen].extension === 'pdf' &&
                listArchivos[indexImagen].Length > 1000000
              "
        >
          <div
              id="pdf-fame"
          >
            <pdf
                v-for="i in numPages"
                :key="i"
                :page="i"
                :src="'data:application/pdf;base64,' + listArchivos[indexImagen].imagenBase64"
                @page-loaded="renderizarPaginas($event)"
                style="
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    border: 3px solid #b4b4b4;
                  "
            ></pdf>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import VisorImagenesECE from "@/components/VisorImagenesECE/VisorImagenesECE.vue";
import {
  S3Client,
  S3ServiceException,
  ListObjectsV2Command,
  //PutObjectCommand,
  GetObjectCommand,
  NoSuchKey,
  DeleteObjectCommand, DeleteObjectsCommand
} from "@aws-sdk/client-s3"
import { Upload } from "@aws-sdk/lib-storage";
//import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import moment from "moment";
import {AwsService} from "../../../apiServices/aws/AwsService";

export default {
  name: "ExploradorArchivoExpedienteV2",
  components: {
    VisorImagenesECE,
    pdf,
  },
  props: {
    rutaSeleccionada: String,
    idPacienteArchivos: Number,
    activarBlnDirectorio: Boolean,
  },
  computed: {
    esImagen() {
      let exprecionRegular = /\.(png|jpe?g)$/i;

      return exprecionRegular.test(this.nombreArchivo);
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    awsServicio: new AwsService(),

    archivoCarga: null,
    listArchivos: [],
    loader: false,
    loaderDescarga : false,
    loaderArchivo: false,
    rutasMostra: [],
    rutaOriginal: "",
    rutaDescargar: "",
    rutaAux: "",
    blnLoaderModal: false,
    numPages: 0,
    numPageCargada: 0.5,
    blnCards: true,
    blnBtnVistaPrevia: false,
    tipoHerramienta: null,
    hoy: null,
    blnBtnHerramientas: true,
    showModalSubirHerramientaOrtodontica: false,
    showModalSubirHerramienta: false,
    listaFlujoExpedinteDigital: [],
    listaArchivoExpedinteDigital: [],
    listaExtensionesHerramienta: [],
    listaExtensiones: [],
    listaArchivosGuardar: [],
    listaArchivoAntesGuardar: [],
    modalVisorImg: false,
    listaVisor: [],
    indexImagen: 0,
    nombreArchivo: '',
    width:0,
    height: 0,

    archivosObtenidos: null,
    token: null,
    archivoDescargando: {
      Name: '',
      contentLength: 0,
      progreso: 0,
      recibido: 0
    },
    activoEnDiagnocat: false,
    loaderDiagnocat: false
  }),
  async created() {
    this.debug = this.$localStorageService.getDebug();
    this.token = this.$localStorageService.getTokenAWS();
    await this.obtenerClinicaDiagnocat();
    await this.validarTokenAWS();

    this.idPaciente = this.idPacienteArchivos;
    this.hoy = this.$moment().format("DD-MM-YYYY");

    this.obtenerFlujosExpediente();
    this.obtenerExtensiones();
    this.width = window.innerWidth;
    this.height = window.innerHeight;
  },
  methods: {
    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAcceso().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWS(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAcceso().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWS(this.token)
        })
      }
    },
    async obtenerArchivosDeCarpeta() {
      this.listArchivos = [];

      let archivosProcesados = this.archivosObtenidos.map(async (archivo) => {
        let rutaComparar = archivo.Key.split('/').slice(0, -1).join('/');
        if (rutaComparar !== this.rutaOriginal) return null;


        let rutasSeparadas = archivo.Key.split('/');
        let nombreArchivo = rutasSeparadas[rutasSeparadas.length - 1];
        let extension = nombreArchivo.split('.').pop();

        let partesNombre = nombreArchivo.split("_");
        let idUser = partesNombre.length > 1 ? partesNombre[partesNombre.length - 1].split('.')[0] : null;

        try {
          let response = await this.$http.post(this.$api + "catalogo/usuario/obtenerUsuario", { idUsuario: idUser });
          let nombreUsuario = response.data?.data || "Desconocido";

          return {
            Name: nombreArchivo,
            extension: extension,
            TimeCreated: archivo.LastModified,
            Length: archivo.Size,
            imagenBase64: null,
            nombreUsuario: nombreUsuario,
            Key: archivo.Key
          };
        } catch (error) {
          console.error("Error obteniendo usuario:", error);
          return null;
        }
      });

      this.listArchivos = (await Promise.all(archivosProcesados)).filter(item => item !== null);
    },

    async getArchivos() {
      await this.validarTokenAWS();
      let config = {
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      }
      const client = new S3Client(config);

      this.listArchivos = [];

      try {
        this.archivosObtenidos.filter(archivo =>{
          let rutasSeparadas = archivo.Key.toString().split('/')
          rutasSeparadas.pop();
          let rutaComparar = "";
          rutasSeparadas.forEach((ruta,index)=>{
            if(index !== rutasSeparadas.length - 1){
              rutaComparar = rutaComparar + ruta + "/"
            }else{
              rutaComparar = rutaComparar + ruta
            }
          })
          if(rutaComparar === this.rutaOriginal){
            return archivo
          }
        }).map(async (archivoObtenido) => {
          const input = {
            Bucket: this.token.nombreBucket,
            Key: archivoObtenido.Key,
          };
          const command = new GetObjectCommand(input);
          const response = await client.send(command);

          const responseS3 = await new Response(response.Body);
          const imageBlob = await responseS3.blob();
          const reader = await new FileReader();
          let idUser = null;
          reader.onloadend = () => {
            archivoObtenido.imagenBase64 = reader.result;
            let rutasSeparadas = archivoObtenido.Key.toString().split('/')
            let extension = rutasSeparadas[rutasSeparadas.length - 1].split('.');
            let name = rutasSeparadas[rutasSeparadas.length - 1];
            idUser = name.split("_")[name.split("_").length-1].split("\\.")[0];
            idUser = idUser.split('.')[0];
            const params = {idUsuario: idUser}
            this.$http.post(this.$api + "catalogo/usuario/obtenerUsuario", params).then((response) => {
              let datos = {Name: name, extension: extension[1], TimeCreated: archivoObtenido.LastModified, Length: archivoObtenido.Size, imagenBase64: archivoObtenido.imagenBase64.split(',')[1], nombreUsuario: response.data.data};
              this.listArchivos.push(datos)
              if(datos.extension === 'jpg' || datos.extension === 'png' || datos.extension === 'jpeg'){
                this.listaVisor.push(datos)
              }
            })
          }
          reader.onerror = error => {
            console.error(error);
          }
          reader.readAsDataURL(imageBlob)
        })
      } catch (caught) {
        if (caught instanceof NoSuchKey) {
          console.error(
              `Error from S3 while getting object "${this.archivosObtenidos[0].Key}" from "${this.token.nombreBucket}". No such key exists.`,
          );
        } else if (caught instanceof S3ServiceException) {
          console.error(
              `Error from S3 while getting object from ${this.token.nombreBucket}.  ${caught.name}: ${caught.message}`,
          );
        } else {
          throw caught;
        }
      }
    },
    async getFolder(blnGuardado, rutaGuardado) {
      await this.validarTokenAWS();
      try{
        this.listArchivos = [];
        let config = {
          region: this.token.regionBucket,
          credentials: {
            accessKeyId: this.token.accessKeyId,
            secretAccessKey: this.token.secretAccessKey,
            sessionToken: this.token.sessionToken,
          },
        }

        const prefixToRemove = "DOCSPRUEBA/";
        if (this.rutaOriginal.startsWith(prefixToRemove)) {  this.rutaOriginal = this.rutaOriginal.substring(prefixToRemove.length);}
        const client = new S3Client(config);
        const input = {
          Bucket: this.token.nombreBucket,
          Prefix: this.rutaOriginal
        };
        const command = new ListObjectsV2Command(input);
        const response = await client.send(command);

        if(response.Contents !== undefined){
          this.archivosObtenidos = response.Contents;
          response.Contents.forEach((datos) => {
            let rutasSeparadas = datos.Key.toString().split('/')
            let extension = rutasSeparadas[rutasSeparadas.length - 1].split('.');
            let name = rutasSeparadas[rutasSeparadas.length - 2];
            let carpeta = {Name: name, extension: extension[1] != null ? "carpeta" : extension[1], TimeCreated: datos.LastModified};
            let archivoRepetido = false;
            this.listArchivos.forEach(archivo => {
              if(archivo.Name === carpeta.Name){
                archivoRepetido = true;
              }
            })
            if(this.listArchivos.length === 0 || !archivoRepetido){
              this.listArchivos.push(carpeta)
            }
          })
          this.loader = false;
          if(blnGuardado === 1){
            await this.verArchivoFolder(rutaGuardado);
          }
        }else{
          this.loader = false;
        }
      }catch (e){
        console.error(e);
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: e,
        });
      }
    },
    obtenerArchivos(ruta, ruta2) {
      this.rutasMostra = ruta2;
      this.rutaOriginal = ruta;
      let listAux = this.rutaOriginal.split("/");
      this.blnBtnHerramientas = listAux[listAux.length - 1] === 'Radiografías y Fotografías';
      this.getFolder(0,null);
      this.blnBtnVistaPrevia = false;
      this.blnCards = true;
      this.loader = true;
    },
    change(e) {
      let file = e.target.files || e.dataTransfer.files;
      if (file[0].name.length >= 60) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "El nombre del archivo es demasiado largo",
        });
      } else {
        this.nuevoArchivo(file);
      }
      e.target.value = "";
    },
    nuevoArchivo(file) {
      const nombreArchivo = file[0].name;
      const nombreCortado = nombreArchivo.split('.');
      let extension = nombreCortado.pop().toLowerCase();

      let archivoAux = {
        nombreArchivo: nombreArchivo,
        estusCarga: true,
      };

      this.listaArchivoAntesGuardar.push(archivoAux);

      let timestamp = Date.now(); // Timestamp actual
      let nombreNuevo = `${this.idPacienteArchivos}_HERRAMIENTA_ORTODONTICA_${timestamp}_${this.$localStorageService.getIdUsuario()}.${extension}`;

      this.listaArchivosGuardar.push({
        file: file[0],  // Guarda el objeto File original
        nombre: nombreNuevo,
        idHerramienta: null,
      });

    },
    async descargarAchivo (archivo) {
      await this.validarTokenAWS();
      this.loaderDescarga = true;
      let config = {
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      }

        try{
          const client = new S3Client(config);
          const input = {
            Bucket: this.token.nombreBucket,
            Key: archivo.Key,
            ResponseCacheControl: "no-cache",
            ResponseContentDisposition: `attachment; filename="${archivo.Name}"`,
          };
          const command = new GetObjectCommand(input);
          const response = await client.send(command);
          const contentLength = response.ContentLength;
          this.archivoDescargando = {
            Name: archivo.Name,
            contentLength: contentLength,
            progreso: 0
          };

          await this.streamDownload(response.Body, archivo.Name, contentLength);


        }catch (caught) {
          if (caught instanceof NoSuchKey) {
            console.error(
                `Error from S3 while getting object "${archivo.key}" from "${this.token.nombreBucket}". No such key exists.`,
            );
          } else if (caught instanceof S3ServiceException) {
            console.error(
                `Error from S3 while getting object from ${this.token.nombreBucket}.  ${caught.name}: ${caught.message}`,
            );
          } else {
            throw caught;
          }
        }
        finally {
          this.loaderDescarga = false;
        }

    },
    async streamDownload(stream, fileName , contentLength) {
      const reader = stream.getReader();
      let receivedSize = 0;
      const chunks = [];

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        receivedSize += value.length;
        this.archivoDescargando.recibido = receivedSize;
        this.archivoDescargando.progreso = Math.round((receivedSize / contentLength) * 100);

      }

      const blob = new Blob(chunks);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    },
    menuDescargar($event, ruta, datos) {
      this.nombreArchivo = ruta.Name;

      if (this.rutaDescargar !== null && this.rutaDescargar !== "") {
        this.rutaDescargar = null;
      }
      if (this.esImagen) {
        this.indexImagen = this.listaVisor.findIndex(lst => lst.Name === this.nombreArchivo);
      } else {
        this.indexImagen = this.listArchivos.findIndex(lst => lst.Name === this.nombreArchivo);
      }
      this.rutaDescargar = ruta;
      this.$refs[datos.menu].open($event);
    },
    menuDescargar2(ruta) {
      if (this.rutaDescargar !== null && this.rutaDescargar !== "") {
        this.rutaDescargar = null;
      }
      this.rutaDescargar = ruta;
      this.verArchivoFolder(null)
    },
    renderizarPaginas($event) {
      this.numPageCargada = $event;
      if (
          this.numPageCargada !== undefined &&
          this.numPageCargada !== null &&
          this.numPageCargada > 0
      ) {
        if (this.numPages === $event) {
          this.blnLoaderModal = false;
        }
      }
    },
    verArchivoFolder(rutaGuardado) {
      if( rutaGuardado !== null){
        this.rutaOriginal = rutaGuardado;
      }else{
        this.rutaOriginal = this.rutaOriginal + "/" + this.rutaDescargar.Name;
      }
      this.rutasMostra = [];
      this.rutaOriginal.split("/").forEach((element) => {
        this.rutasMostra.push({text: element});
      });
      this.blnBtnVistaPrevia = true;
      this.obtenerArchivosDeCarpeta();
    },
    ocultarDirectorio() {
      this.$emit("obtenerBlnDirectorio", !this.activarBlnDirectorio);
    },
    async ocultarCards() {
      await this.getArchivosBase64();
      this.blnCards = !this.blnCards;
    },
    async eliminarArchivo() {
      await this.validarTokenAWS();
      this.rutaAux = this.rutaOriginal + "/" + this.rutaDescargar.Name;

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      const deleteParams = {
        Bucket: this.token.nombreBucket, // Nombre de tu bucket
        Key: this.rutaAux, // Ruta del archivo a eliminar
      };

      // Ejecutar el comando para eliminar el archivo
      const deleteCommand = new DeleteObjectCommand(deleteParams);
      await client.send(deleteCommand)
          .then(() => {
            const index = this.listArchivos.findIndex(archivo => archivo.Key === this.rutaAux);
            if (index !== -1) {
              this.listArchivos.splice(index, 1);
            }

            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: "Se elimino el archivo correctamente",
            });
          })
          .catch(() => {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error",
            });
          })
          .finally(() => {
            // Limpiar la ruta auxiliar
            this.rutaAux = '';
          });
    },
    /***/
    subirHerramientaModal() {
      this.showModalSubirHerramienta = true;
    },
    subirHerramientaOrtodonticaModal() {
      this.showModalSubirHerramientaOrtodontica = true;
    },
    obtenerFlujosExpediente() {
      this.$http.get(this.$api + 'catalogos/obtenerFlujoExpedinteDigital').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaFlujoExpedinteDigital.push(it);
              })
            }
          }
      )
    },
    obtenerArchivoExpedientePorFlujo(e) {
      this.listaArchivoExpedinteDigital = [];
      this.$http.post(this.$api + 'herramientaExpedienteElectronico/obtenerHerramientasECEFlujo', e).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaArchivoExpedinteDigital.push(it);
              })
            }
          }
      )
    },
    async changeArchivoHerramienta(e) {
      let files = e.target.files || e.dataTransfer.files;

      for (let i = 0; i < files.length; i++) {
        const nombreArchivo = files[i].name;
        const nombreCortado = nombreArchivo.split('.');
        let extension = nombreCortado.pop().toLowerCase(); // Extrae la extensión

        let archivoAux = {
          nombreArchivo: nombreArchivo,
          estusCarga: this.listaExtensionesHerramienta.includes(extension),
        };

        this.listaArchivoAntesGuardar.push(archivoAux);


        if (archivoAux.estusCarga) {
          let timestamp = Date.now() + i; // Timestamp actual
          let nombreNuevo = `${this.idPacienteArchivos}_${this.tipoHerramienta.nombreHerramienta}_${timestamp}_${this.$localStorageService.getIdUsuario()}.${extension}`;

          this.listaArchivosGuardar.push({
            file: files[i],  // Guarda el objeto File original
            nombre: nombreNuevo,
            idHerramienta: this.tipoHerramienta.idHerramienta,
          });
        }
      }
    },
    obtieneExtensionesArchivo(e) {
      this.tipoHerramienta = e;
      this.listaExtensionesHerramienta = [];
      e.extensiones.forEach(ext => {
        this.listaExtensionesHerramienta.push(ext.extension.toLowerCase());
      });
      if (this.$refs['file-input']) {
        this.$refs['file-input'].reset();
      }
    },
    cerrarModalHerramienta() {
      this.tipoHerramienta = null;
      this.showModalSubirHerramienta = false;
      this.showModalSubirHerramientaOrtodontica = false;
      this.listaArchivoAntesGuardar =[];
      this.listaArchivosGuardar = [];
    },
    async guardarHerramienta() {
      await this.validarTokenAWS();

      if (this.listaArchivosGuardar.length === 0) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Debes subir al menos un archivo de tipo " + this.listaExtensionesHerramienta.toString(),
        });
        this.cerrarModalHerramienta();
        return false;
      }

      this.loaderArchivo = true;

      let ruta = this.tipoHerramienta.rutaGuardarDigital.replace("#id_paciente", this.idPacienteArchivos.toString());
      let nombreCarpeta = `${this.tipoHerramienta.flujo.flujoExpedienteDigial} ${this.hoy}`;

      const prefixToRemove = "DOCSPRUEBA/";
      if (ruta.startsWith(prefixToRemove)) {
        ruta = ruta.substring(prefixToRemove.length);
      }

      let rutaDirectorio = `${ruta}/${nombreCarpeta}`;
      let archivosSubidos = [];

      let objetoEnviar = {
        idHerramienta: this.tipoHerramienta.idHerramienta,
        idPaciente: this.idPacienteArchivos,
        rutaDirectorio: rutaDirectorio,
        listaArchivos: this.listaArchivosGuardar,
      };

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        for (const [index, archivo] of this.listaArchivosGuardar.entries()) {
          try {
            let filePath = `${rutaDirectorio}/${archivo.nombre}`;
            const input = {
              Bucket: this.token.nombreBucket,
              Key: filePath,
              Body: archivo.file,
              ContentType: archivo.file.type,
            };

            const upload = new Upload({
              client: client,
              params: input,
              partSize: 5 * 1024 * 1024, // Multipart upload para archivos grandes
              queueSize: 4,
            });

            upload.on("httpUploadProgress", (progress) => {
              const porcentaje = Math.round((progress.loaded / progress.total) * 100);
              this.$set(this.listaArchivoAntesGuardar[index], "progreso", porcentaje);
            });

            await upload.done();
            archivosSubidos.push(filePath);
          } catch (error) {
            console.error(`Error al subir el archivo ${archivo.nombre}:`, error);
            throw error;
          }
        }

        const response = await this.$http.post(
            this.$api + "herramientaExpedienteElectronico/subirHerramienta",
            objetoEnviar
        );

        if (!response.data.success) {
          throw new Error("Error al guardar en la base de datos");
        }

        this.archivoCarga = null;
        this.tipoHerramienta = null;
        this.cerrarModalHerramienta();

        this.rutaOriginal = ruta;
        await this.getFolder(1, rutaDirectorio);

        this.$swal.fire({
          icon: "success",
          title: "Éxito",
          text: `Se subieron correctamente los archivos: ${archivosSubidos.map(a => a.split('/').pop()).join(", ")}`,
        });

      }
      catch (error) {
        console.error("Error en el proceso:", error);

        if (archivosSubidos.length > 0) {
          try {
            const deleteParams = {
              Bucket: this.token.nombreBucket,
              Delete: {
                Objects: archivosSubidos.map((filePath) => ({ Key: filePath })),
              },
            };
            const deleteCommand = new DeleteObjectsCommand(deleteParams);
            await client.send(deleteCommand);
            console.log("Archivos revertidos correctamente en S3.");
          } catch (deleteError) {
            console.error("Error al eliminar archivos de S3:", deleteError);
          }
        }

        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: `Hubo un problema: ${error.message}`,
        });

      }
      finally {
        this.loaderArchivo = false;
        this.listaArchivoAntesGuardar = [];
        this.listaArchivosGuardar = [];
        if (this.$refs['file-input']) {
          this.$refs['file-input'].reset();
        }
      }
    },
    obtenerExtensiones() {
      this.$http.get(this.$api + 'catalogos/obtenerExtensiones').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaExtensiones.push(it);
              })
            }
          }
      )
    },
    async mostrarVisor(nombre) {
      await this.getArchivosBase64();
      if (nombre !== null) {
        let extencion = nombre.split(".")
        if (extencion[1] !== 'png' &&
            extencion[1] !== 'jpg' &&
            extencion[1] !== 'jpeg' &&
            extencion[1] !== 'pdf') {
          return;
        }
      }

      if (nombre !== null) {
        this.nombreArchivo = nombre;
      }

      if (this.esImagen) {
        this.indexImagen = this.listaVisor.findIndex(lst => lst.Name === this.nombreArchivo);
      } else if (!this.esImagen) {
        this.indexImagen = this.listArchivos.findIndex(lst => lst.Name === this.nombreArchivo);

        if (this.listArchivos[this.indexImagen].Length > 1000000) {
          this.numPages = 0;
          this.numPageCargada = 1;
          let pdfDocument = pdf.createLoadingTask(
              "data:application/pdf;base64," + this.listArchivos[this.indexImagen].imagenBase64
          );
          pdfDocument.promise.then((pdf) => {
            this.numPages = pdf.numPages;
          });
        }

      }
      this.modalVisorImg = true;
    },
    async getArchivosBase64() {
      await this.validarTokenAWS();

      let config = {
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      };
      const client = new S3Client(config);
      this.listaVisor = [];

      for (let archivo of this.listArchivos) {
        const ext = archivo.extension.toLowerCase();
        if (!["png", "jpg", "jpeg", "pdf"].includes(ext) || archivo.imagenBase64 !== null) {
          if(archivo.extension === 'jpg' || archivo.extension === 'png' || archivo.extension === 'jpeg'){
            this.listaVisor.push(archivo)
          }
          continue; // Saltamos archivos no válidos
        }

        try {
          const input = {
            Bucket: this.token.nombreBucket,
            Key: archivo.Key, // Ahora sí recorremos la lista
          };
          const command = new GetObjectCommand(input);
          const response = await client.send(command);

          const responseS3 = await new Response(response.Body);
          const imageBlob = await responseS3.blob();

          // Convertir a Base64 usando una Promesa
          archivo.imagenBase64 = await this.convertBlobToBase64(imageBlob);

          // Si es una imagen, agregar a `listaVisor`
          if (["jpg", "png", "jpeg"].includes(archivo.extension.toLowerCase())) {
            this.listaVisor.push(archivo);
          }
        } catch (error) {
          console.error(`Error al obtener ${archivo.Key}:`, error);
        }
      }
    },

    convertBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    async guardarHerramientaOrtodontica() {
      await this.validarTokenAWS();

      if (this.listaArchivosGuardar.length === 0) {
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Debes subir al menos un archivo de tipo " + this.listaExtensionesHerramienta.toString(),
        });
        this.cerrarModalHerramienta();
        return false;
      }

      this.loaderArchivo = true;
      let rutaTerminaEnFecha = /\d{2}-\d{2}-\d{4}$/;

      let rutaDirectorio = rutaTerminaEnFecha.test(this.rutaOriginal)
          ? this.rutaOriginal
          : this.rutaOriginal + '/' + this.hoy;

      let archivosSubidos = [];

      let objetoEnviar = {
        idHerramienta: null,
        idPaciente: this.idPacienteArchivos,
        rutaDirectorio: rutaDirectorio,
        listaArchivos: this.listaArchivosGuardar,
      };

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        for (const [index, archivo] of this.listaArchivosGuardar.entries()) {
          try {
            let filePath = `${rutaDirectorio}/${archivo.nombre}`;
            const input = {
              Bucket: this.token.nombreBucket,
              Key: filePath,
              Body: archivo.file,
              ContentType: archivo.file.type,
            };

            const upload = new Upload({
              client: client,
              params: input,
              partSize: 5 * 1024 * 1024, // Multipart upload para archivos grandes
              queueSize: 4,
            });

            upload.on("httpUploadProgress", (progress) => {
              const porcentaje = Math.round((progress.loaded / progress.total) * 100);
              this.$set(this.listaArchivoAntesGuardar[index], "progreso", porcentaje);
            });

            await upload.done();
            archivosSubidos.push(filePath);
          } catch (error) {
            console.error(`Error al subir el archivo ${archivo.nombre}:`, error);
            throw error;
          }
        }

        const response = await this.$http.post(
            this.$api + "herramientaExpedienteElectronico/subirHerramienta",
            objetoEnviar
        );

        if (!response.data.success) {
          throw new Error("Error al guardar en la base de datos");
        }

        this.archivoCarga = null;
        this.tipoHerramienta = null;
        this.cerrarModalHerramienta();

        await this.getFolder(1, rutaDirectorio);

        this.$swal.fire({
          icon: "success",
          title: "Éxito",
          text: `Se subieron correctamente los archivos: ${archivosSubidos.map(a => a.split('/').pop()).join(", ")}`,
        });

      }
      catch (error) {
        console.error("Error en el proceso:", error);

        if (archivosSubidos.length > 0) {
          try {
            const deleteParams = {
              Bucket: this.token.nombreBucket,
              Delete: {
                Objects: archivosSubidos.map((filePath) => ({ Key: filePath })),
              },
            };
            const deleteCommand = new DeleteObjectsCommand(deleteParams);
            await client.send(deleteCommand);
            console.log("Archivos revertidos correctamente en S3.");
          } catch (deleteError) {
            console.error("Error al eliminar archivos de S3:", deleteError);
          }
        }

        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: `Hubo un problema: ${error.message}`,
        });

      }
      finally {
        this.loaderArchivo = false;
        this.listaArchivoAntesGuardar = [];
        this.listaArchivosGuardar = [];
        if (this.$refs['file-input']) {
          this.$refs['file-input'].reset();
        }
      }
    },
    async obtenerClinicaDiagnocat() {
      return await this.$http
          .post(
              this.$api +
              "diagnocat/validarClinica",{"idClinica":this.$localStorageService.getIdClinica()}
          )
          .then((response) => {
            this.activoEnDiagnocat = response.data.data;
          })
    },
    autoguardadoDiagnoEce(){
      this.loaderDiagnocat = true;
      this.$http.post(this.$api + "diagnocat/autoguardadoExpedienteClinicoElectronicoDiagnocat",{"idPaciente":this.idPaciente}).then((response) => {
        response.data.data
      }).finally(
          () => {
            this.loaderDiagnocat = false;
          }
      )
    },
  },
};
</script>

<style scoped>
.file {
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
}

.file-input label {
  display: block;
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgb(5, 92, 173);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: transform 0.2s ease-out;
  font-size: 15px;
}

.file-name {
  position: absolute;
  bottom: -35px;
  left: 5px;
  font-size: 0.2rem;
  color: rgb(75, 75, 75);
}

input:hover + label,
input:focus + label {
  transform: scale(1.02);
}

/* Adding an outline to the label on focus */
input:focus + label {
  outline: 1px solid #000;
  outline: -webkit-focus-ring-color auto 2px;
}

.md-theme-default a:not(.md-button) {
  color: #0c5460 !important;
}

.datitos > p {
  margin-bottom: 0.4rem;
}


.archivo-frame {
  width: 100% !important;
  height: 77vh !important;
}

#pdf-fame {
  border: 22px solid #b4b4b4;
}

.btn-file {
  position: relative;
  overflow: hidden;
}

.btn-file input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: white;
  cursor: inherit;
  display: block;
}

.redondeo{
  border-radius: 10px !important;
}
.modal-footer {
  justify-content: center !important;
}

.table.b-table > thead > tr > .table-b-table-default {
  color: #5d5d5d !important;
  background-color: #ffffff !important;
}

.romperTexto {
  word-break: break-all;
}

.estiloCards {
  width:100%;
  max-height: 35em;
  overflow-y: auto;
}

.tamanioImg {
  object-fit: cover;
  border-radius: 14px;
  max-height: 10vw;
  min-height: 10vh;
}

@media (min-width: 1200px) {
  .tamanioImg-lg {
    object-fit: cover;
    border-radius: 14px;
    max-height: 7vw;
    min-height: 7vh;
  }
}

</style>
